import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';
import MonthToDate from '../MonthToDate';



class Dashboard extends Component{
    render(){
        return(
            <div>
                <div className="row">
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="content-header">
                                <h1>Cloud Integration</h1>
                                <div id="azure_bar">
                                    <h2>Azure</h2>
                                    <h3>Portal: <a target="_blank" href="https://portal.azure.com">https://portal.azure.com</a></h3>
                                </div>
                            </div>
                            <MonthToDate/>
                        </div>
                    </div>
                </div>
                <div className="primary">
                    <div className="container-fluid">
                        {this.props.UsersList}
                    </div>
                </div>
            </div>
        );
    }
}


export default Dashboard;


/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/Dashboard.js
 **/